import React, { Component } from "react";
import PropTypes from "prop-types";
import ButtonInputUpload from "./buttonInputUpload";
import { FormattedMessage } from "react-intl";

class DropZone extends Component {
  static propTypes = {
    handleDrop: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {};
    /** TODO creare il ref solo in caso di upload drag & drop */
    this.dropRef = React.createRef();

    this.handleDrag = e => {
      e.preventDefault();
      e.stopPropagation();
    };

    this.handleDragIn = e => {
      e.preventDefault();
      e.stopPropagation();
      this.dragCounter++;
      if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
        this.setState({ drag: true });
      }
    };

    this.handleDragOut = e => {
      e.preventDefault();
      e.stopPropagation();
      this.dragCounter--;
      if (this.dragCounter === 0) {
        this.setState({ drag: false });
      }
    };

    this.handleDrop = e => {
      e.preventDefault();
      e.stopPropagation();
      this.setState({ drag: false });
      if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        this.props.handleDrop(e.dataTransfer.files);
        e.dataTransfer.clearData();
        this.dragCounter = 0;
      }
    };
  }

  componentDidMount() {
    let div = this.dropRef.current;
    div.addEventListener("dragenter", this.handleDragIn);
    div.addEventListener("dragleave", this.handleDragOut);
    div.addEventListener("dragover", this.handleDrag);
    div.addEventListener("drop", this.handleDrop);
  }

  componentWillUnmount() {
    let div = this.dropRef.current;
    div.removeEventListener("dragenter", this.handleDragIn);
    div.removeEventListener("dragleave", this.handleDragOut);
    div.removeEventListener("dragover", this.handleDrag);
    div.removeEventListener("drop", this.handleDrop);
  }

  render() {
    const { disabled } = this.props;
    return (
      <div className="dropZone" ref={this.dropRef}>
        {" "}
        <span><FormattedMessage id="upload.widget.title" /></span>
        <ButtonInputUpload disabled={disabled} handleUpload={this.props.handleDrop} />
      </div>
    );
  }
}

export default DropZone;
